const KEY = 'growdaily-offline-owner';
async function fingerprint() {
  const token = localStorage.getItem('session_token');
  if (!token || !globalThis.crypto?.subtle) return null;
  const digest = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(token));
  return Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('');
}
// This identifies local storage only. It is never an authenticated user and
// never carries premium/admin permissions or authorizes server requests.
export async function rememberOfflineOwner(user) {
  try {
    const session = await fingerprint();
    if (session && user?.user_id) localStorage.setItem(KEY, JSON.stringify({ owner: user.user_id, session }));
  } catch { /* Local persistence may be disabled. */ }
}
export async function readOfflineOwner() {
  try {
    const value = JSON.parse(localStorage.getItem(KEY));
    return value?.session && value.session === await fingerprint() ? value.owner : null;
  } catch { return null; }
}
export function forgetOfflineOwner() { try { localStorage.removeItem(KEY); } catch { /* unavailable */ } }
